const ITEMS = [
  '⚠ ЭМИ-БУРЯ НАД C-1 ДО 06:00',
  '★ СЕЗОН 03 «СТАЛЬНОЙ ГОД» — 14 ДНЕЙ',
  '⚡ −20% НА НАНО-СТИМ ДО ПОЛУНОЧИ',
  '◗ TOP-1 КОТ НЕДЕЛИ: ПЫШКА · 312 KILLS',
  '◇ НОВЫЙ МОДУЛЬ В РАЗРАБОТКЕ',
];

export function NewsTicker() {
  return (
    <div
      style={{
        padding: '5px 0',
        margin: '0 16px 4px',
        borderRadius: 8,
        background: 'linear-gradient(90deg, rgba(0,0,0,0.4) 0%, rgba(8,16,38,0.55) 50%, rgba(0,0,0,0.4) 100%)',
        boxShadow: 'inset 0 0 0 1px rgba(245,197,66,0.18), inset 0 1px 0 rgba(255,255,255,0.05)',
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <span
        className="news-badge"
        style={{
          position: 'absolute',
          left: 6,
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 2,
          padding: '2px 6px',
          color: '#2a1700',
          fontFamily: 'var(--f-display)',
          fontSize: 8.5,
          letterSpacing: '0.14em',
          borderRadius: 4,
          boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.5), 0 1px 3px rgba(0,0,0,0.4)',
        }}
      >NEWS</span>
      <div
        className="ticker-track"
        style={{
          fontFamily: 'var(--f-display)',
          fontSize: 10.5,
          letterSpacing: '0.14em',
          color: 'var(--gold-hi)',
          paddingLeft: 56,
          whiteSpace: 'nowrap',
        }}
      >
        {[...ITEMS, ...ITEMS].map((s, i) => (
          <span key={i} style={{ marginRight: 60 }}>
            <span style={{ color: 'var(--cyan)', marginRight: 8 }}>◆</span>{s}
          </span>
        ))}
      </div>
    </div>
  );
}
